export default {
    // 兼容safari
    // 把字符串转化为Safari支持的格式
    // yyyy/MM/dd HH:mm:ss或yyyy-MM-ddTHH:mm:ss或其他
    changeDate(date){
        if(date){
            if(typeof date == 'string'){
                return date.replace(/-/g, '/')
            }else {
                let day = date.toLocaleDateString();
                let times = date.toLocaleTimeString();
                if(times.indexOf('上午') !== -1 || times.indexOf('下午') !== -1){
                    times = this.conversionTime(times)
                }
                let val = day + ' ' + times
                return val;
            }
        }else {
            return date
        }
       
        
    },
    conversionTime (time) {
        var dayTime = time.substring(0, 2) // 当前time类型 ，上午和下午
        var currentTime = time.substring(2, time.length) // 当前时间（只保留后面时间戳）
        if (dayTime === '下午' && timiList[0].trim() !== '12') { // 对下午的时间进行操作
            var timeList = currentTime.split(':') // 转化为数组
            timeList[0] = Number(timeList[0]) + 12 // 第0个数组为当前小时数， + 12
            currentTime = timeList.toString().replace(/,/g, ':') // 转化为标准时间格式 00:00:00
        }
       
        return currentTime
       
    },
}